import {TLocation, TLocationType, TLocationsTree} from '~/services/hot-api';
import {PromotionCategory, PromotionChildCategory} from '~/services/hot-api/categories';

type FlatedChildCategory = PromotionChildCategory & {nameExt: string};

export type TFlatCategories = Array<PromotionCategory | FlatedChildCategory>;

export const flatCategoires = (categories: PromotionCategory[]) => {
  const result: TFlatCategories = [];

  categories.forEach((category) => {
    if (category.categories) {
      const childCategories = category.categories.map((childCategory) => ({
        ...childCategory,
        nameExt: `${category.name} - ${childCategory.name}`,
      }));
      result.push(...childCategories);
    } else {
      result.push(category);
    }
  });

  return result;
};

export const filterNotExistsCategories = (selected: number[], flat: TFlatCategories) =>
  selected.filter((id) => Boolean(flat.find((category) => category.id === id)));

type LocationMeta = {
  [key in TLocationType]?: string;
} & {
  [key in TLocationType as `${key}Id`]?: string;
};

export type TFlatLocation = TLocation & {meta: LocationMeta};

export interface TFlatLocationsMap {
  [key: number]: TFlatLocation;
}

export const flatLocations = (countres: TLocationsTree) => {
  const result: TFlatLocationsMap = {};

  const parseTree = (locations: any) => {
    return locations.map((location: any) => {
      result[location.id] = location;

      if (!location.items) {
        return;
      }

      const populatedLocations = location.items.map((item: any) => ({
        meta: {
          ...location.meta,
          [location.type]: location.name,
          [`${location.type}Id`]: location.id,
        },
        ...item,
      }));

      return parseTree(populatedLocations);
    });
  };

  parseTree(countres);

  return result;
};

export const filterNotExistsLocations = (selected: number[], flat: TFlatLocationsMap) => {
  const nonExistsLocations: number[] = [];

  const filteredLocations = selected.filter((id) => {
    const location = flat[id];

    if (!location) {
      nonExistsLocations.push(id);
      return false;
    }

    return true;
  });

  if (nonExistsLocations.length > 0) {
    console.warn('Some locations are not exists', nonExistsLocations.join(', '));
  }

  return filteredLocations;
};
